module.exports = __webpack_public_path__ + "img/1_x4.86f43ce3.png";